// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"d998ab3a","342":"7444002b","365":"0c9c56c1","683":"97c9c3bc"}[chunkId] + ".chunk.js";
};